// extracted by mini-css-extract-plugin
export default {"riderList":"rider-list_riderList__IH68L","rider":"rider-list_rider__znP-h","col":"rider-list_col__+u+yz","noRiders":"rider-list_noRiders__SsxHb"};